import TrailerReducer from './reducers';
import trailerSaga from './sagas';
import * as trailerActions from './actions';

export {trailerSaga, trailerActions};
export default TrailerReducer;